import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Stack, Divider} from '@salesforce/retail-react-app/app/components/shared/ui'

import ItemVariantProvider from '/overrides/app/components/item-variant'
import CartItemVariantImage from '/overrides/app/components/item-variant/item-image'
import CartItemVariantName from '/overrides/app/components/item-variant/item-name'
import CartItemVariantAttributes from '/overrides/app/components/item-variant/item-attributes'
import CartItemPromotionBadge from '/overrides/app/components/item-variant/item-promotion-badge'
import CartHeader from './cart-header'
import {useCartProducts} from './hooks/useCartProducts'

const CartItems = ({basket}) => {
    // Use custom hook for products data
    const {totalItems, products} = useCartProducts(basket)

    return (
        <>
            <CartHeader totalItems={totalItems} />
            <Stack spacing={5} align="flex-start" w="full">
                {basket.productItems?.map((product, idx) => {
                    const variant = {
                        ...product,
                        ...(products && products[product.productId]),
                        price: product.price
                    }

                    return (
                        <ItemVariantProvider key={product.productId} index={idx} variant={variant}>
                            <Flex width="full" alignItems="flex-end" justify="space-between" py={2}>
                                <CartItemVariantImage width="84px" height="105px" mr={5} />
                                <Box flex="1" minW={0}>
                                    <CartItemPromotionBadge />
                                    <CartItemVariantName
                                        fontSize="md"
                                        fontWeight="bold"
                                        color="black"
                                        mb={1}
                                        lineHeight="normal"
                                    />
                                    <CartItemVariantAttributes
                                        productAttributesStyles={{
                                            size: 'md',
                                            color: {hex: 'gray.400'}
                                        }}
                                    />
                                </Box>
                            </Flex>
                        </ItemVariantProvider>
                    )
                })}
            </Stack>
        </>
    )
}

CartItems.propTypes = {
    basket: PropTypes.object
}

export default CartItems
